import { MenuCategoryEnum } from "@shared/enum/menu.enum";
import { RoleEnum } from "@shared/enum/role.enum";
import { RouteEnum } from "@shared/enum/route.enum";
import { ILeftMenuItem } from "@shared/interface/menu.interface";
import { $t } from 'src/i18n/utils/index';

export const menuList: Array<ILeftMenuItem> = [
    /**
     * Menu : main
     */
    {
        icon: 'home',
        label: $t('layoutLeftSide.menu.home'),
        topSeparator: false,
        bottomSeparator: false,
        pageLink: RouteEnum.HOME,
        category: MenuCategoryEnum.MAIN
    },
    {
        icon: 'checklist',
        label: $t('layoutLeftSide.menu.programs'),
        topSeparator: false,
        bottomSeparator: true,
        pageLink: RouteEnum.PROGRAMS,
        category: MenuCategoryEnum.MAIN
    },
    // {
    //     icon: 'healing',
    //     label: $t('layoutLeftSide.menu.specialWeapons'),
    //     topSeparator: false,
    //     bottomSeparator: true,
    //     pageLink: RouteEnum.WEAPONS,
    //     category: MenuCategoryEnum.MAIN
    // },
    {
        icon: 'email',
        label: $t('layoutLeftSide.menu.contact'),
        topSeparator: false,
        bottomSeparator: false,
        pageLink: RouteEnum.CONTACT,
        category: MenuCategoryEnum.MAIN
    },
    {
        icon: 'list_alt',
        label: $t('layoutLeftSide.menu.changelog'),
        topSeparator: false,
        bottomSeparator: false,
        pageLink: RouteEnum.CHANGELOG,
        caption: `Version : ${process.env.FRONTEND.currentVersion ?? 'null'}`,
        authorizedRoles: [RoleEnum.ROLE_READ],
        category: MenuCategoryEnum.MAIN
    },

    /**
     * Menu : Admin
     */
    {
        icon: 'group',
        label: $t('layoutLeftSide.menu.users'),
        topSeparator: false,
        bottomSeparator: false,
        pageLink: RouteEnum.USERS,
        authorizedRoles: [
            RoleEnum.ROLE_ADMIN,
            RoleEnum.ROLE_SUPER_ADMIN,
            RoleEnum.ROLE_USER_VALIDATE,
        ],
        category: MenuCategoryEnum.ADMIN
    },
    {
        icon: 'videocam',
        label: $t('layoutLeftSide.menu.videos'),
        topSeparator: false,
        bottomSeparator: true,
        pageLink: RouteEnum.VIDEOS,
        authorizedRoles: [
            RoleEnum.ROLE_VIDEO_ADD,
            RoleEnum.ROLE_VIDEO_VALIDATE,
            RoleEnum.ROLE_SUPER_ADMIN,
        ],
        category: MenuCategoryEnum.ADMIN
    },

    /**
     * Menu : Developer
     */
    {
        icon: 'key',
        label: $t('layoutLeftSide.menu.session'),
        topSeparator: false,
        bottomSeparator: false,
        pageLink: RouteEnum.DEVELOPER_SESSION,
        authorizedRoles: [
            RoleEnum.ROLE_DEV,
        ],
        category: MenuCategoryEnum.DEVELOPER
    }, {
        icon: 'bug_report',
        label: $t('layoutLeftSide.menu.console'),
        topSeparator: false,
        bottomSeparator: true,
        pageLink: RouteEnum.DEVELOPER_CONSOLE,
        authorizedRoles: [
            RoleEnum.ROLE_DEV,
        ],
        category: MenuCategoryEnum.DEVELOPER
    },
];